import React from "react";
import "./WhurzIt.css"

const WhurzItThree = () => (
  <div>

	<h1>Encryption</h1>
    <p>WhurzIt uses <a href={"https://www.npmjs.com/package/crypto-js/"} 
    target={"_blank"}>crypto-js</a> to encrypt its data using the AES 128 bit
    encryption mechanism to encrypt both data stored in the cloud and backed up
    on a local computer.</p>

    <p>AES is the <b>ONLY</b> publicly accessible cipher approved by the National 
	Security Agency (NSA) for encrypting top secret information.</p>

  </div>
);

export default WhurzItThree;


// WEBPACK FOOTER //
// ./src/components/WhurzIt/WhurzItThree.js